import { useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
import { buildGscSectionHref } from "@/lib/gsc-section-href";
import { cn } from "@/lib/utils";

const GSC_ROUTES = [
  { path: "/gsc", label: "Overview", end: true },
  { path: "/gsc/detail", label: "Detail", end: false },
  { path: "/gsc/compare", label: "Compare", end: false },
] as const;

export const GscSubNav = () => {
  const { pathname, search } = useLocation();

  const hrefByPath = useMemo(() => {
    const map = new Map<string, string>();
    for (const route of GSC_ROUTES) {
      map.set(route.path, buildGscSectionHref(route.path, search));
    }
    return map;
  }, [search]);

  return (
    <nav
      aria-label="GSC sections"
      className="flex w-fit flex-wrap gap-1 rounded-lg border border-border bg-card p-1"
    >
      {GSC_ROUTES.map((route) => {
        const isActive = route.end
          ? pathname === route.path
          : pathname.startsWith(route.path);

        return (
          <Link
            key={route.path}
            to={hrefByPath.get(route.path) ?? route.path}
            className={cn(
              "rounded-md px-3 py-1.5 text-sm font-medium transition-colors",
              isActive
                ? "bg-primary text-primary-foreground"
                : "text-muted-foreground hover:bg-muted hover:text-foreground",
            )}
          >
            {route.label}
          </Link>
        );
      })}
    </nav>
  );
};
